import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';

import { FileSpecification } from 'src/app/models/file-specifications/file-specification';
import { FileSpecificationVideosSettings } from 'src/app/models/file-specifications/file-specification-settings';

import {
  specMetaBadge,
  videoBitRateLabel,
  videoFormatLabel,
  videoSizeLabel,
} from '../shared/spec-labels';

@Component({
  selector: 'app-video-format-config-view',
  templateUrl: './video-format-config-view.component.html',
  styleUrls: ['./video-format-config-view.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class VideoFormatConfigViewComponent {
  @Input() videosSpecs: FileSpecification[] = [];
  @Input() loaded = false;
  @Input() canWrite = false;
  @Input() canAudit = false;

  @Output() createVideos = new EventEmitter<void>();
  @Output() updateVideos = new EventEmitter<FileSpecification>();
  @Output() deleteVideos = new EventEmitter<FileSpecification>();
  @Output() viewVideosHistory = new EventEmitter<FileSpecification>();

  private videosSettings(spec: FileSpecification): FileSpecificationVideosSettings {
    return spec.value.settings as FileSpecificationVideosSettings;
  }

  metaBadge(spec: FileSpecification) {
    return specMetaBadge(spec);
  }

  formatLabel(spec: FileSpecification): string {
    return videoFormatLabel(this.videosSettings(spec).format);
  }

  sizeLabel(spec: FileSpecification): string {
    const settings = this.videosSettings(spec);
    return videoSizeLabel(settings.width, settings.height);
  }

  bitRateLabel(spec: FileSpecification): string {
    return videoBitRateLabel(this.videosSettings(spec).bitRate);
  }

  onCreateVideos(): void {
    this.createVideos.emit();
  }

  onUpdateVideos(row: FileSpecification): void {
    this.updateVideos.emit(row);
  }

  onDeleteVideos(row: FileSpecification): void {
    this.deleteVideos.emit(row);
  }

  onViewVideosHistory(row: FileSpecification): void {
    this.viewVideosHistory.emit(row);
  }
}
